export enum MerchantIPNStatus {
  Pending = 'Pending',
  Done = 'Done',
  Failed = 'Failed',
  Expired = 'Expired',
  Verified = 'Verified'
}

export enum MerchantExchangeWithdrawIPNStatus {
  Failed = 'Failed',
  Exchanged = 'Exchanged',
  Done = 'Done'
}

export enum MerchantExchangeIPNStatus {
  Failed = 'Failed',
  Done = 'Done'
}
